var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('vue-page-transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }